// Imports

//=require vanilla-lazyload/dist/lazyload.min.js
// //=require svg4everybody/dist/svg4everybody.min.js

// svg4everybody();
// var lazyLoadInstance = new LazyLoad({
//     use_native: true,
//     elements_selector: '.lazyload',
//     class_loaded: 'lazyloaded'
// });

//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js
//=require css-element-queries/src/ResizeSensor.js
//=require sticky-js/dist/sticky.min.js
//=require @popperjs/core/dist/umd/popper.min.js
//=require tippy.js/dist/tippy-bundle.umd.min.js

//=require ../source/js/tools/tools.go-to-element.js
//=require ../source/js/tools/tools.filter-input.js
//=require ../source/js/tools/tools.stop-transition-on-resize.js
//=require ../source/js/tools/tools.focus-on-keydown.js
//=require ../source/js/tools/tools.trap-focus.js
//=require ../source/js/tools/tools-load-search-posts-json.js
//=require ../source/js/tools/tools-load-category-posts-json.js
//=require ../source/js/tools/tools.form-insurances.js


//=require ../source/js/components/components.input-filters.js
//=require ../source/js/components/components.site-header.js
//=require ../source/js/components/components.forms.js
//=require ../source/js/components/components.tables.js
//=require ../source/js/components/components.office-locator.js
//=require ../source/js/components/components.faqs.js
//=require ../source/js/components/components.expandable-content.js
//=require ../source/js/components/components.tippy-poppers.js

const osanoTrigger = {
    init() {
        const triggers = document.querySelectorAll('.js-osano-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', event => {
                event.preventDefault();
                Osano.cm.showDoNotSell();
                const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
                closeButtonDialog?.focus();
            });
        });
    }
};


window.addEventListener('load', event => {
    osanoTrigger.init();
});
